import { FC, ReactNode } from 'react';
import { HeaderGroup } from '@tanstack/react-table';
import MainTitleRow from './MainTitleRow';
import HeaderFilterRow from './HeaderFilterRow';
import { TableSort } from '../..';
import st from './Header.module.scss';

interface ITableHeaderGroupProps {
	group: HeaderGroup<any>;
	sort?: TableSort;

	allowFilters?: boolean;
	minColumnSize?: number;

	renderFirstToolbar?: () => ReactNode;
	renderFilter?: (columnsId: string) => React.ReactNode;
}

const TableHeaderGroup: FC<ITableHeaderGroupProps> = (props) => {
	const {
		sort,
		group,
		minColumnSize,
		allowFilters,
		renderFirstToolbar,
		renderFilter,
	} = props;

	return (
		<thead className={st.header}>
			<MainTitleRow
				sort={sort}
				minColumnSize={minColumnSize}
				headerGroup={group}
				renderFirstToolbar={renderFirstToolbar}
			/>
			{allowFilters && (
				<HeaderFilterRow
					rowExpanding={!!renderFirstToolbar}
					headerGroup={group}
					renderFilter={renderFilter}
				/>
			)}
		</thead>
	);
};

export default TableHeaderGroup;
